import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from "@mui/material";
import { Section } from "@sunwing/components";
import { Icon } from "__ICON_REFERENCE__";

import { withRouter } from "utilities/withRouter";
import quote from "services/quote/quote.service";
import View from "components/quote/view/index";
import PageHeader from "components/common/pageHeader/pageHeader";
import commonUtilities from "utilities/common";
import { CONFIGURATION } from "utilities/configuration";
import { CONSTANTS } from "utilities/constants";

import "./viewQuote.css";

class ViewQuote extends Component {

    componentDidMount() {
        this.getQuote();
    }

    onClose = () => {
        this.props.navigate("/review");
    };

    getQuote = async () => {
        if (this.props.params) {
            await this.props.dispatch({ type: "QUOTE_RESET" });
            let { quoteNumber } = this.props.params;
            this.props.showLoadingSpinner(true);
            await this.props.dispatch(quote.get(quoteNumber));
            this.props.showLoadingSpinner(false);
        }
    };

    componentWillUnmount() {
        this.props.dispatch({ type: "QUOTE_RESET" });
    }

    canCustomizeQuote(quote) {
        let canCustomize = false;
        const TODAY = commonUtilities.getTodayDate();
        if(quote?.data) {
            canCustomize = quote?.data?.status !== "Confirmed";
            if(canCustomize) {
                // must have some live options with un-pending itinerary
                let hasNoExpiredItinerary = false;
                let hasPendingItinerary = false;
                quote?.data?.quoteOptions.forEach(option => {
                    const productTypeCode = option?.productType?.code?.toLowerCase();
                    if(productTypeCode) {
                        if(productTypeCode === CONSTANTS.DEVIATION) {
                            if(option.deviationItinerary) {
                                if(option.deviationItinerary.status?.toLowerCase() === "pending") {
                                    hasPendingItinerary = true; 
                                }
                                if(option.deviationItinerary.itineraryValidDate) {
                                    const days = commonUtilities.calculateDuration(TODAY, option.deviationItinerary.itineraryValidDate);
                                    if(days >= 0) {
                                        hasNoExpiredItinerary = true;
                                    }
                                }
                            }
                        }
                        else {
                            if(option.products) {
                                option.products.forEach(product => {
                                    if(product.itineraries) {
                                        product.itineraries.forEach(itinerary => {
                                            if(itinerary.status?.toLowerCase() === "pending") {
                                                hasPendingItinerary = true; 
                                            }
                                            if(itinerary.itineraryValidDate) {
                                                const days = commonUtilities.calculateDuration(TODAY, itinerary.itineraryValidDate);
                                                if(days >= 0) {
                                                    hasNoExpiredItinerary = true;
                                                }
                                            }
                                        });
                                    }
                                });
                            }
                        }
                    }
                    
                });
                canCustomize = (!hasPendingItinerary && hasNoExpiredItinerary);
            }
        }
        return canCustomize;
    }

    render() {

        let { quote, groupTypes } = this.props;
        if(!quote?.data) return null;

        const canCustomize = CONFIGURATION.CUSTOMIZE_QUOTE_ENABLE 
            && commonUtilities.isAgent(this.props.userType) 
            && this.canCustomizeQuote(quote);

        const showEventLogo = (quote?.data?.groupInformation?.eventName ?? "") !== "";

        return (
            <div className="row margin-bottom-4x review-group-responsive">

                <div className="row">
                    <Section className="print-hide">
                        <div className="page-main-container margin-bottom-1x">
                            <PageHeader showLogoIfExists={true} showEventLogo={showEventLogo} />
                        </div>
                    </Section>
                    <Section className="print-hide">
                        {
                            this.props.params?.type?.toLowerCase() === "review"
                                ? <div className="row">
                                    <Button
                                        onClick={() => this.onClose()}
                                        data-testid="close-button"
                                        variant="text"
                                        className="pull-right"
                                    >
                                        <Icon
                                            name="close--n"
                                            className="cursor-pointer icon-16 margin-right"
                                        />
                                        {this.props.localize("qma-close")}
                                    </Button>
                                </div>
                                : null
                        }

                    </Section>
                </div>
                <View quote={quote} navigate={this.props.navigate} params={this.props.params} canCustomize={canCustomize} groupTypes={groupTypes}/>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    quote: state.quote,
    groupTypes: state.groupTypes
});

export default connect(mapStateToProps)(withRouter(ViewQuote));